export default function LogoMark({ size = 40, withWordmark = true, dark = false }) {
  return (
    <span className="inline-flex items-center gap-3" data-testid="logo-mark">
      <img
        src="/logo-mark.png"
        alt="Emblema Agro Carmo"
        width={size}
        height={size}
        className="shrink-0 rounded-xl shadow-md shadow-black/25"
      />
      {withWordmark && (
        <span className="leading-none">
          <span
            className={`block font-display text-xl font-semibold tracking-tight ${
              dark ? "text-parchment" : "text-ink"
            }`}
          >
            Agro Carmo
          </span>
          <span className="mt-1 block font-mono text-[10px] uppercase tracking-[0.22em] text-clay">
            Agropecuária & Pet
          </span>
        </span>
      )}
    </span>
  );
}
